var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.playground,
      expression: "loading.playground"
    }],
    attrs: {
      "title": _vm.sessionType
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "left",
      "label-width": "200px",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "ID"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.payload.id,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "id", $$v);
      },
      expression: "payload.id"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.payload.name,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "name", $$v);
      },
      expression: "payload.name"
    }
  })], 1), _vm.isZipGeneration && _vm.payload.target_url ? _c('el-form-item', {
    attrs: {
      "label": "ZIP file"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.payload.target_url,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(" Open ZIP ")])]) : _vm._e(), !_vm.isZipGeneration ? [_vm.payload.session_id ? _c('el-form-item', {
    attrs: {
      "label": "Session Id"
    }
  }, [_c('a', {
    attrs: {
      "href": `https://dev.animaapp.com/chat/${_vm.payload.session_id}`,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.payload.session_id) + " ")])]) : _vm._e(), _vm.dbUrl ? _c('el-form-item', {
    attrs: {
      "label": "DB Url"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.dbUrl,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.dbUrl) + " ")])]) : _vm._e(), _vm.payload.design_file_url ? _c('el-form-item', {
    attrs: {
      "label": "Design File URL"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.payload.design_file_url,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.payload.design_file_url) + " ")])]) : _vm._e(), _vm.payload.live_url ? _c('el-form-item', {
    attrs: {
      "label": "Live URL"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.payload.live_url,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.payload.live_url) + " ")])]) : _vm._e(), _vm.payload.subdomain ? _c('el-form-item', {
    attrs: {
      "label": "Subdomain"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.payload.subdomain,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "subdomain", $$v);
      },
      expression: "payload.subdomain"
    }
  })], 1) : _vm._e(), _vm.payload.target_url ? _c('el-form-item', {
    attrs: {
      "label": "Code Files"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.payload.target_url,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.payload.target_url) + " ")])]) : _vm._e(), _vm.payload.file_key ? _c('el-form-item', {
    attrs: {
      "label": "File Key"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.payload.file_key,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "file_key", $$v);
      },
      expression: "payload.file_key"
    }
  })], 1) : _vm._e(), _vm.payload.custom_hostnames && _vm.payload.custom_hostnames.length ? _c('el-form-item', {
    attrs: {
      "label": "Custom Domains"
    }
  }, _vm._l(_vm.payload.custom_hostnames, function (hostname) {
    return _c('el-tag', {
      key: hostname,
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_c('a', {
      attrs: {
        "href": `https://${hostname}`,
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(hostname) + " ")])]);
  }), 1) : _vm._e()] : _vm._e(), _c('el-form-item', {
    attrs: {
      "label": "Created at"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "disabled": ""
    },
    model: {
      value: _vm.payload.created_at,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "created_at", $$v);
      },
      expression: "payload.created_at"
    }
  })], 1)]), _c('el-form-item', {
    attrs: {
      "label": "Updated at"
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "disabled": ""
    },
    model: {
      value: _vm.payload.updated_at,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "updated_at", $$v);
      },
      expression: "payload.updated_at"
    }
  })], 1)]), _vm.ownerDetails.email ? _c('el-form-item', {
    attrs: {
      "label": "Owner"
    }
  }, [_c('router-link', {
    attrs: {
      "to": `/customers/user/${_vm.ownerDetails.email}`
    }
  }, [_vm._v(" " + _vm._s(_vm.ownerDetails.email) + " ")])], 1) : _c('el-form-item', {
    attrs: {
      "label": "Owner ID"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.payload.owner,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "owner", $$v);
      },
      expression: "payload.owner"
    }
  })], 1), _vm.teamDetails.name ? _c('el-form-item', {
    attrs: {
      "label": "Team"
    }
  }, [_c('router-link', {
    attrs: {
      "to": `/customers/team/${_vm.teamDetails.id}`
    }
  }, [_vm._v(" " + _vm._s(_vm.teamDetails.name) + " ")])], 1) : _c('el-form-item', {
    attrs: {
      "label": "Team ID"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.payload.team,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "team", $$v);
      },
      expression: "payload.team"
    }
  })], 1), !_vm.isZipGeneration ? [_c('el-form-item', {
    attrs: {
      "label": "Sandbox Type"
    }
  }, [_c('el-radio-group', {
    model: {
      value: _vm.sandboxType,
      callback: function ($$v) {
        _vm.sandboxType = $$v;
      },
      expression: "sandboxType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "inherit"
    }
  }, [_vm._v("Inherit")]), _c('el-radio', {
    attrs: {
      "label": "csb"
    }
  }, [_vm._v("Sandpack")]), _c('el-radio', {
    attrs: {
      "label": "webcontainer"
    }
  }, [_vm._v("Web Container")])], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Abuse"
    }
  }, [_vm.payload.live_url ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.unpublishPlayground
    }
  }, [_vm._v(" Unpublish ")]) : _vm._e(), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.takedownPlayground
    }
  }, [_vm._v("Takedown")]), _c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.whitelistAbuseScan
    }
  }, [_vm._v("Whitelist scan")]), _c('el-button', {
    on: {
      "click": _vm.removeAbuseScanWhitelist
    }
  }, [_vm._v("Remove scan whitelist")])], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])], 1)] : _vm._e()], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }